import "./consultorio.scss";

export default function Consultorio() {
  return (
    <section id="consultorio" className="section consultorio-page">
      <div className="container section-title fade-up text-center mb-5">
        <h2>Requisitos para trabajar en Consultorio</h2>
      </div>

      <div className="container">
        <div className="row gy-4 align-items-start">
          {/* Panel izquierdo */}
          <div className="col-lg-4 fade-up">
            <div className="info-visual-panel">
              <div className="deadline-alert">
                <i className="bi bi-calendar-event"></i>
                <span>
                  La documentación se recibe del{" "}
                  <strong>1 al 15 de cada mes</strong>, con cita previa. Pasado
                  ese plazo, se traslada al mes siguiente.
                </span>
              </div>

              <div className="stat-card">
                <div className="stat-icon cyan">
                  <i className="bi bi-file-earmark-text"></i>
                </div>
                <div className="stat-info">
                  <h4>AFIP e Ingresos Brutos</h4>
                  <p>Constancias de inscripción fiscal obligatorias</p>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon green">
                  <i className="bi bi-building-check"></i>
                </div>
                <div className="stat-info">
                  <h4>Habilitación de Consultorio</h4>
                  <p>Expedida por el Ministerio de Salud de La Pampa</p>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon violet">
                  <i className="bi bi-card-checklist"></i>
                </div>
                <div className="stat-info">
                  <h4>Registro Nacional</h4>
                  <p>Inscripción con número de matrícula COFOLP</p>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon amber">
                  <i className="bi bi-shield-check"></i>
                </div>
                <div className="stat-info">
                  <h4>Seguro de Mala Praxis</h4>
                  <p>Constancia de seguro vigente al momento del trámite</p>
                </div>
              </div>

              <div className="stat-card">
                <div className="stat-icon rose">
                  <i className="bi bi-hospital"></i>
                </div>
                <div className="stat-info">
                  <h4>Obras Sociales</h4>
                  <p>
                    Compromiso mínimo de 6 meses en el Listado de Prestadores
                  </p>
                </div>
              </div>

              <div className="info-highlight">
                <i className="bi bi-info-circle-fill"></i>
                <p>
                  <strong>Capacitación requerida:</strong> El matriculado/a debe
                  realizar la capacitación de facturación por Obra Social a
                  cargo del Colegio antes de comenzar a operar.
                </p>
              </div>
            </div>
          </div>

          {/* Panel derecho */}
          <div className="col-lg-8 fade-up">
            <div className="content-panel">
              <h5 className="requirements-title">
                <i className="bi bi-list-check"></i>
                Documentación requerida
              </h5>
              <ul className="req-list">
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>Constancia de Inscripción ante AFIP</span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Constancia de Inscripción en el Impuesto a los Ingresos
                    Brutos
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Habilitación de Consultorio expedida por el Ministerio de
                    Salud de La Pampa, a nombre del matriculado
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Inscripción en Registro Nacional de Prestadores con el
                    número de matrícula de COFOLP
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Certificado de Ética Profesional extendido por el Colegio (o
                    por otro Colegio en caso de haber pertenecido o pertenecer)
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>Constancia de seguro de mala praxis vigente</span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Libre de deuda expedido por el Área Contable del Colegio
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Declaración Jurada en donde el/la matriculado/a se
                    compromete a informar cambio de situación fiscal
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Declaración Jurada de conformidad para ingresar al Listado
                    de Prestadores y trabajar con las Obras Sociales, mutuales o
                    prepagas con las que el Colegio mantiene convenios
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Realizar capacitación de facturación por Obra Social a cargo
                    del Colegio
                  </span>
                </li>
                <li>
                  <i className="bi bi-check2-all"></i>
                  <span>
                    Aceptación y conformidad de mantener la permanencia en el
                    Listado de Prestadores que trabajan con Obras Sociales por
                    un mínimo de 6 meses
                  </span>
                </li>
              </ul>

              <div className="download-actions">
                <a
                  href="/assets/portal/docs/SOL_INSCRIP_SUPERINTENDENCIA_DE_SALUD.pdf"
                  className="btn-download primary"
                  target="_blank"
                >
                  <i className="bi bi-download"></i>
                  Descargar Solicitud Inscripción Superintendencia
                </a>
                <a
                  href="/assets/portal/docs/SOL_INSCRIP_REG_NAC_DE_PRESTADORES.pdf"
                  className="btn-download secondary"
                  target="_blank"
                >
                  <i className="bi bi-download"></i>
                  Descargar Solicitud Registro Nacional de Prestadores
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
